import { ReactComponent as Add } from 'assets/icons/icon-add.svg';

export default Add;
